import ContentsDispatcher from "./ContentsDispatcher";
import { Suspense, useEffect } from "react";
import { useRecoilValue } from "recoil";
import { pointAreaUpdateState, useCustomerExternalFileListVisible } from "../../../store/PointAreaSettingState";

const PointAreaDispatcherInner = (props) => {
  const customerExternalFileList = useCustomerExternalFileListVisible();

  useEffect(()=>{
    if (customerExternalFileList !== null) {
      props.contents.setExternalFileList(customerExternalFileList);
    }
  }, [customerExternalFileList, props.contents]);

  return (
    <ContentsDispatcher {...props}/>
  );
}

const PointAreaDispatcher = (props) => {
  const {contents} = props;

  const pointAreaUpdate = useRecoilValue(pointAreaUpdateState);

  useEffect(() => {
    contents.resetData();
  },[pointAreaUpdate, contents]);

  return (
    <Suspense fallback={""}>
      <PointAreaDispatcherInner {...props} />
    </Suspense>
  );
};

export default PointAreaDispatcher;
